import React, { Component } from 'react'
import styled from 'styled-components'

class _DropdownArrow extends Component {

  constructor (props) {
    super(props)
  }

  render () {
    return (
      <span className={this.props.className}>
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 9 12"
          width={this.props.width}
          height={this.props.height}
          preserveAspectRatio="xMidYMid meet">
          <g>
            <path id="path0_fill" fillRule="evenodd" d="M 0 0L 9 6L 0 12L 0 0Z" fill="#CBCBCB" />
          </g>
        </svg>
      </span>
    )
  }
}

const DropdownArrow = styled(_DropdownArrow)`
  display: inline-block;
  float: right;

  svg {
    transform: rotateZ(180deg);
    /* TODO Correct the rotation pivot point on dropdown-arrow */
    transition: transform 300ms ease-in-out;

    ${props => props.isOpen && `
      transform: rotateZ(90deg);
    `}
  }
`

export default DropdownArrow



// WEBPACK FOOTER //
// ./src/components/visuals/DropdownArrow.js